export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '转盘抽奖记录';
